import moment from 'moment';
import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';
import {downloadFile} from '../../common/util/file';
import {dateFormatShow} from '../../common/constants/datesFormat';

const INITIAL_STATE = {
  'loading': false,
  'downloading': false,
  'partData': {},
  'filterCodeText': '',
  'filterDescriptionText': '',
  'filterMotorText': '',
  'filterBrandText': '',
  'filterLocationText': '',
  'filterClassificationText': '',
  'filterOriginText': '',
  'list': [],
  'page': [],
  'pageSize': 20,
  'pageNumber': 0,
  'itemsCount': 0,
  'dataSheetUrl': '',
  'downloadingDataSheet': false,
};

const FORM_INITIAL_STATE = {
  'loading': false,
  'loadingWeeklyMoves': false,
  'loadingWeeklyAnalysis': false,
  'selectedPartData': {},
  'weeklyMoves': [],
  'weeklyAnalysis': [],
};

const MODALS_INITIAL_STATE = {
  'loadingTdeStockDetail': false,
  'loadingStockDetail': false,
  'loadingBackOrdersDetail': false,
  'loadingOnOrdersDetail': false,
  'loadingBinningPendingDetail': false,
  'loadingWarehouseStockDetail': false,
  'loadingInvoicesConfirmedDetail': false,
  'loadingReservations': false,
  'tdeStockDetail': {},
  'stockDetail': {},
  'backOrdersDetail': [],
  'onOrdersDetail': {},
  'binningPendingDetail': [],
  'warehouseStockDetail': [],
  'invoicesConfirmedDetail': [],
  'reservations': [],
  'reserveDetail': [],
};

export const parts = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_PARTS_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_PARTS_LIST]: (state, action) => ({
      ...state,
      'list': action.response.data,
      'page': action.response.data,
      'itemsCount': action.response.count,
      'loading': false,
    }),
    [ActionTypes.FETCHED_PARTS_LIST_FAILED]: (state, action) => ({
      ...state,
      'list': [],
      'page': [],
      'itemsCount': 0,
      'loading': false,
    }),
    [ActionTypes.DOWNLOADING_PARTS_LIST]: (state, action) => ({
      ...state,
      'downloading': true,
    }),
    [ActionTypes.DOWNLOADED_PARTS_LIST]: (state, action) => {
      downloadFile(action.response.data);
      
      return ({
        ...state,
        'downloading': false,
      });
    },
    [ActionTypes.DOWNLOADED_PARTS_LIST_FAILED]: (state, action) => ({
      ...state,
      'downloading': false,
    }),
    [ActionTypes.FETCHING_PART]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_PART]: (state, action) => ({
      ...state,
      'loading': false,
      'partData': action.response.data,
    }),
    [ActionTypes.FETCHED_PART_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'partData': {},
    }),
    [ActionTypes.FETCHING_ANALYSIS_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_ANALYSIS_LIST]: (state, action) => ({
      ...state,
      'list': action.response.data,
      'page': action.response.data,
      'itemsCount': action.response.count,
      'loading': false,
    }),
    [ActionTypes.FETCHED_ANALYSIS_LIST_FAILED]: (state, action) => ({
      ...state,
      'list': [],
      'page': [],
      'itemsCount': 0,
      'loading': false,
    }),
    [ActionTypes.CHANGE_CODE_TEXT_FILTER]: (state, action) => ({
      ...state,
      'filterCodeText': action.payload,
    }),
    [ActionTypes.CHANGE_DESCRIPTION_TEXT_FILTER]: (state, action) => ({
      ...state,
      'filterDescriptionText': action.payload,
    }),
    [ActionTypes.CHANGE_MOTOR_TEXT_FILTER]: (state, action) => ({
      ...state,
      'filterMotorText': action.payload,
    }),
    [ActionTypes.CHANGE_BRAND_TEXT_FILTER]: (state, action) => ({
      ...state,
      'filterBrandText': action.payload,
    }),
    [ActionTypes.CHANGE_LOCATION_TEXT_FILTER]: (state, action) => ({
      ...state,
      'filterLocationText': action.payload,
    }),
    [ActionTypes.CHANGE_CLASSIFICATION_TEXT_FILTER]: (state, action) => ({
      ...state,
      'filterClassificationText': action.payload,
    }),
    [ActionTypes.CHANGE_ORIGIN_TEXT_FILTER]: (state, action) => ({
      ...state,
      'filterOriginText': action.payload,
    }),
    [ActionTypes.CLEAR_FILTERS]: (state, action) => ({
      ...state,
      'filterCodeText': '',
      'filterDescriptionText': '',
      'filterMotorText': '',
      'filterBrandText': '',
      'filterLocationText': '',
      'filterClassificationText': '',
      'filterOriginText': '',
      'downloading': false,
      'list': [],
      'page': [],
      'itemsCount': 0,
    }),
    [ActionTypes.CHANGE_PARTS_LIST_PAGE]: (state, action) => ({
      ...state,
      'pageNumber': action.payload,
    }),
    [ActionTypes.CHANGE_PARTS_LIST_PAGE_SIZE]: (state, action) => ({
      ...state,
      'pageSize': action.payload,
      'pageNumber': 0,
    }),
    [ActionTypes.GENERATING_DATA_SHEET]: (state, action) => ({
      ...state,
      'downloadingDataSheet': true,
    }),
    [ActionTypes.GENERATED_DATA_SHEET_FAILED]: (state, action) => ({
      ...state,
      'downloadingDataSheet': false,
      'dataSheetUrl': '',
    }),
    [ActionTypes.GENERATED_DATA_SHEET]: (state, action) => ({
      ...state,
      'downloadingDataSheet': false,
      'dataSheetUrl': action.response.data,
    }),
    [ActionTypes.CLEAR_DATA_SHEET_URL]: (state, action) => ({
      ...state,
      'dataSheetUrl': '',
    }),
  })(state, action);
};

function getManualMadValidity(status, date) {
  const today = moment();
  if (date === null || (date && !status && moment(date) < today)) {
    return today.format(dateFormatShow);
  }
  return moment(date).format(dateFormatShow);
}

export const partForm = (state, action) => {
  return createReducer(FORM_INITIAL_STATE, {
    [ActionTypes.FETCHING_ANALYSIS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_ANALYSIS]: (state, action) => ({
      ...state,
      'selectedPartData': action.response.data,
      'loading': false,
      'weeklyAnalysis': [],
      'values': {
        'classification': action.response.data.classification,
        'appliesPriceChange': action.response.data.appliesPriceChange || false,
        'manualMadStatus': action.response.data.manualMadStatus || false,
        'manualMad': action.response.data.manualMad || 0,
        'manualMadValidity': getManualMadValidity(action.response.data.manualMadStatus || false,
          action.response.data.manualMadValidity),
      },
    }),
    [ActionTypes.FETCHED_ANALYSIS_FAILED]: (state, action) => ({
      ...state,
      'selectedPartData': {},
      'loading': false,
      'weeklyAnalysis': [],
    }),
    [ActionTypes.GET_PART_WEEKLY_MOVES_REQUEST]: (state, action) => ({
      ...state,
      'loadingWeeklyMoves': true,
    }),
    [ActionTypes.GET_PART_WEEKLY_MOVES_SUCCESS]: (state, action) => ({
      ...state,
      'loadingWeeklyMoves': false,
      'weeklyMoves': action.response.data,
    }),
    [ActionTypes.GET_PART_WEEKLY_MOVES_FAILED]: (state, action) => ({
      ...state,
      'loadingWeeklyMoves': false,
      'weeklyMoves': [],
    }),
    [ActionTypes.FETCHING_WEEKLY_ANALYSIS]: (state, action) => ({
      ...state,
      'loadingWeeklyAnalysis': true,
    }),
    [ActionTypes.FETCHED_WEEKLY_ANALYSIS]: (state, action) => ({
      ...state,
      'loadingWeeklyAnalysis': false,
      'weeklyAnalysis': action.response.data,
    }),
    [ActionTypes.FETCHED_WEEKLY_ANALYSIS_FAILED]: (state, action) => ({
      ...state,
      'loadingWeeklyAnalysis': false,
      'weeklyAnalysis': [],
    }),
  })(state, action);
};

export const partModals = (state, action) => {
  return createReducer(MODALS_INITIAL_STATE, {
    [ActionTypes.FETCHING_TDE_STOCK_DETAIL]: (state, action) => ({
      ...state,
      'loadingTdeStockDetail': true,
    }),
    [ActionTypes.FETCHED_TDE_STOCK_DETAIL]: (state, action) => ({
      ...state,
      'loadingTdeStockDetail': false,
      'tdeStockDetail': action.response.data,
    }),
    [ActionTypes.FETCHED_TDE_STOCK_DETAIL_FAILED]: (state, action) => ({
      ...state,
      'loadingTdeStockDetail': false,
      'tdeStockDetail': {},
    }),
    [ActionTypes.FETCHING_STOCK_DETAIL]: (state, action) => ({
      ...state,
      'loadingStockDetail': true,
    }),
    [ActionTypes.FETCHED_STOCK_DETAIL]: (state, action) => ({
      ...state,
      'loadingStockDetail': false,
      'stockDetail': action.response.data,
    }),
    [ActionTypes.FETCHED_STOCK_DETAIL_FAILED]: (state, action) => ({
      ...state,
      'loadingStockDetail': false,
      'stockDetail': {},
    }),
    [ActionTypes.FETCHING_BACK_ORDERS_DETAIL]: (state, action) => ({
      ...state,
      'loadingBackOrdersDetail': true,
    }),
    [ActionTypes.FETCHED_BACK_ORDERS_DETAIL]: (state, action) => ({
      ...state,
      'loadingBackOrdersDetail': false,
      'backOrdersDetail': action.response.data,
    }),
    [ActionTypes.FETCHED_BACK_ORDERS_DETAIL_FAILED]: (state, action) => ({
      ...state,
      'loadingBackOrdersDetail': false,
      'backOrdersDetail': [],
    }),
    [ActionTypes.FETCHING_ON_ORDERS_DETAIL]: (state, action) => ({
      ...state,
      'loadingOnOrdersDetail': true,
    }),
    [ActionTypes.FETCHED_ON_ORDERS_DETAIL]: (state, action) => ({
      ...state,
      'loadingOnOrdersDetail': false,
      'onOrdersDetail': action.response.data,
    }),
    [ActionTypes.FETCHED_ON_ORDERS_DETAIL_FAILED]: (state, action) => ({
      ...state,
      'loadingOnOrdersDetail': false,
      'onOrdersDetail': {},
    }),
    [ActionTypes.FETCHING_WAREHOUSE_STOCK_DETAIL]: (state, action) => ({
      ...state,
      'loadingWarehouseStockDetail': true,
    }),
    [ActionTypes.FETCHED_WAREHOUSE_STOCK_DETAIL]: (state, action) => ({
      ...state,
      'loadingWarehouseStockDetail': false,
      'warehouseStockDetail': action.response.data,
    }),
    [ActionTypes.FETCHED_WAREHOUSE_STOCK_DETAIL_FAILED]: (state, action) => ({
      ...state,
      'loadingWarehouseStockDetail': false,
      'warehouseStockDetail': [],
    }),
    [ActionTypes.FETCHING_BINNING_PENDING_DETAIL]: (state, action) => ({
      ...state,
      'loadingBinningPendingDetail': true,
    }),
    [ActionTypes.FETCHED_BINNING_PENDING_DETAIL]: (state, action) => ({
      ...state,
      'loadingBinningPendingDetail': false,
      'binningPendingDetail': action.response.data,
    }),
    [ActionTypes.FETCHED_BINNING_PENDING_DETAIL_FAILED]: (state, action) => ({
      ...state,
      'loadingBinningPendingDetail': false,
      'binningPendingDetail': [],
    }),
    [ActionTypes.FETCHING_INVOICES_CONFIRMED_DETAIL]: (state, action) => ({
      ...state,
      'loadingInvoicesConfirmedDetail': true,
    }),
    [ActionTypes.FETCHED_INVOICES_CONFIRMED_DETAIL]: (state, action) => ({
      ...state,
      'loadingInvoicesConfirmedDetail': false,
      'invoicesConfirmedDetail': action.response.data,
    }),
    [ActionTypes.FETCHED_INVOICES_CONFIRMED_DETAIL_FAILED]: (state, action) => ({
      ...state,
      'loadingInvoicesConfirmedDetail': false,
      'invoicesConfirmedDetail': [],
    }),
    [ActionTypes.GET_PART_STOCK_RESERVATIONS_REQUEST]: (state, action) => ({
      ...state,
      'loadingReservations': true,
    }),
    [ActionTypes.GET_PART_STOCK_RESERVATIONS_SUCCESS]: (state, action) => ({
      ...state,
      'loadingReservations': false,
      'reservations': action.response.data,
    }),
    [ActionTypes.GET_PART_STOCK_RESERVATIONS_FAILED]: (state, action) => ({
      ...state,
      'loadingReservations': false,
      'reservations': [],
    }),
    [ActionTypes.FETCHING_RESERVE_DETAIL]: (state, action) => ({
      ...state,
      'loadingBackOrdersDetail': true,
    }),
    [ActionTypes.FETCHED_RESERVE_DETAIL]: (state, action) => ({
      ...state,
      'loadingBackOrdersDetail': false,
      'reserveDetail': action.response.data,
    }),
    [ActionTypes.FETCHED_RESERVE_DETAIL_FAILED]: (state, action) => ({
      ...state,
      'loadingBackOrdersDetail': false,
      'reserveDetail': [],
    }),
  })(state, action);
};
